import users from '@/store/modules/interactions/searches/users';

export default {
    users,
};
